import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";

import { CartProvider } from "./context/CartContext";
import { ProtectedRoute } from "./context/AuthContext";

import WhatsAppIcon from "./components/WhatsAppIcon";

import Login from "./login/Login";
import UpdatePasswordPage from "./login/UpdatePasswordPage";

import AdminPanel from "./login/Administrador/AdminPanel";
import Configurations from "./login/Administrador/AdminPanel/Configurations";

import EnterprisePanel from "./login/Empresa/EnterprisePanel";

import AdminProducts from "./login/Administrador/AdminProducts";
import Products from "./login/Administrador/AdminProducts/Products";
import ProductDetail from "./login/Administrador/AdminProducts/ProductDetail";
import Categories from "./login/Administrador/AdminProducts/Categories";

import AdminPerson from "./login/Administrador/AdminPerson";
import AdminRegister from "./login/Administrador/AdminRegister";

import AdminOrden from "./login/Administrador/AdminOrden";
import NewOrden from "./login/Administrador/AdminOrden/NewOrden";
import Complement from "./login/Administrador/AdminOrden/Complement";

import AdminInvoice from "./login/Administrador/AdminInvoice";
import AdminDocuments from "./login/Administrador/AdminDocuments";
import AdminStatistics from "./login/Administrador/AdminStatistics";

function PublicWhatsApp() {
  const location = useLocation();

  const allowedPaths = [
    "/",
    "/login",
    "/actualizar-password",
    "/actualizar-clave",
    "/system/update-password",
  ];

  if (!allowedPaths.includes(location.pathname)) {
    return null;
  }

  return <WhatsAppIcon />;
}

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <PublicWhatsApp />

        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/actualizar-password" element={<UpdatePasswordPage />} />
          <Route path="/actualizar-clave" element={<UpdatePasswordPage />} />
          <Route path="/system/update-password" element={<UpdatePasswordPage />} />

          <Route path="/admin-panel" element={<ProtectedRoute><AdminPanel /></ProtectedRoute>} />
          <Route path="/admin-panel/configuracion" element={<ProtectedRoute><Configurations /></ProtectedRoute>} />
          <Route path="/admin-panel/empresa" element={<ProtectedRoute><EnterprisePanel /></ProtectedRoute>} />

          <Route path="/admin-panel/productos" element={<ProtectedRoute><AdminProducts /></ProtectedRoute>} />
          <Route path="/admin-panel/productos/lista" element={<ProtectedRoute><AdminProducts /></ProtectedRoute>} />
          <Route path="/admin-panel/productos/nuevo" element={<ProtectedRoute><Products /></ProtectedRoute>} />
          <Route path="/admin-panel/productos/categorias" element={<ProtectedRoute><Categories /></ProtectedRoute>} />
          <Route path="/admin-panel/productos/:productId" element={<ProtectedRoute><ProductDetail /></ProtectedRoute>} />

          <Route path="/admin-panel/personas" element={<ProtectedRoute><AdminPerson /></ProtectedRoute>} />
          <Route path="/admin-panel/caja" element={<ProtectedRoute><AdminRegister /></ProtectedRoute>} />

          <Route path="/admin-panel/ordenes" element={<ProtectedRoute><AdminOrden /></ProtectedRoute>} />
          <Route path="/admin-panel/ordenes/nueva" element={<ProtectedRoute><NewOrden /></ProtectedRoute>} />
          <Route path="/admin-panel/ordenes/sabores" element={<ProtectedRoute><Complement /></ProtectedRoute>} />

          <Route path="/admin-panel/facturacion" element={<ProtectedRoute><AdminInvoice /></ProtectedRoute>} />
          <Route path="/admin-panel/facturas" element={<ProtectedRoute><AdminDocuments /></ProtectedRoute>} />
          <Route path="/admin-panel/documentos" element={<ProtectedRoute><AdminDocuments /></ProtectedRoute>} />
          <Route path="/admin-panel/facturas/nueva" element={<ProtectedRoute><AdminInvoice /></ProtectedRoute>} />
          <Route path="/admin-panel/facturacion/nueva" element={<ProtectedRoute><AdminInvoice /></ProtectedRoute>} />
          <Route path="/admin-panel/estadisticas" element={<ProtectedRoute><AdminStatistics /></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;